import React, { useEffect, useState, useCallback } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { useRouteMatch } from "react-router";

const NaverPowerLink = () => {
    const categoryArr = []
    const categoryData = useSelector(state => state.category.categoryData)
    categoryData.map(cate => {
        if(cate.child_count > 0){
            cate.child.map(cate2 => {
                categoryArr[cate2.cate_id] = cate2.cate_keyword
                if(cate2.child_count > 0){
                    cate2.child.map(cate3 => {
                        categoryArr[cate3.cate_id] = cate3.cate_keyword
                        if(cate3.child_count > 0){
                            cate3.child.map(cate4 => {
                                categoryArr[cate4.cate_id] = cate4.cate_keyword
                                if(cate4.child_count > 0){
                                    cate4.child.map(cate5 => {
                                        categoryArr[cate5.cate_id] = cate5.cate_keyword
                                        return null
                                    })
                                }
                                return null
                            })
                        }
                        return null
                    })
                }
                return null
            })
        }
        categoryArr[cate.cate_id] = cate.cate_keyword
        return null
    })

    const match = useRouteMatch()
    const categoryKey = match.params.categoryID ? match.params.categoryID : '1010100000'
    let keyword = categoryArr[categoryKey]
    const [powerLinkList, setPowerLinkList] = useState([])
    const {domain} = useSelector(state => state.initial)
    let channel = ''
    if(domain === 'shopping'){
        channel = "pping.ch3"
    }else{
        channel = "pping.ch5"
    }

    const apiCall = useCallback(async () => {

        let testParam = ''
        if(process.env.REACT_APP_TLD === 'kr') testParam = false
        else testParam = true

        window.NAVER_ADPOST_V2({
            channel: channel,
            pageSize: 10,
            query: keyword,
            test: testParam,
            mock: false
        })

        window.handle_naver_ads_response = (result) => {
            //console.log(result.ads)
            setPowerLinkList(result.ads)
        }

    }, [keyword, channel]);

    useEffect(() => {
        apiCall();
    }, [keyword, apiCall])
    return (
        <div>
            {powerLinkList && powerLinkList.length !== 0 ? (
                <Case>
                    <div className='powerLinkAdTitle'>
                        <em>파워링크</em>
                        <a href="http://saedu.naver.com/adbiz/searchad/intro.nhn" target="_blank" rel='noopener noreferrer'>신청하기 &gt;</a>
                        <span className='adSpan'>광고</span>
                        <span className='adDetail'> 광고상품입니다. 실제 구매가격은 할인율, 옵션 선택에 따라 달라질 수 있습니다.</span>
                    </div>
                    <div className='powerLinkAdList'>
                        <ul>
                            {powerLinkList.length !== 0 && powerLinkList?.map((v, i) => {
                                return(
                                    <li data-type="powerlink" key={i}>
                                        <a href={v.clickUrl} target="_blank" rel='noopener noreferrer'>
                                            {v.imageExtension ?
                                                <span className="powerLinkThumb">
                                                    <img src={v.imageExtension.imageUrl} alt='파워링크 이미지'/>
                                                </span> : ''}

                                                    <span className='powerLinkInfo'>
                                                        <span className='powerLinkInfoName'>
                                                            {v.headline}
                                                            {v.naverPayIconType === 0 ? <i className='naverEmpty'></i> : (v.naverPayIconType === 1 ? <i className='naverPay'></i> : <i className='naverPayPlus'></i>)}
                                                        </span>
                                                            <span className='powerLinkInfoDetail'>{v.description}</span>
                                                    </span>
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </Case>
            ) : ('')}
        </div>
    );
}
const Case = styled.div`
    display: block;
    position: relative;
    letter-spacing: -.5px;
    margin-top: 40px;

    & > .powerLinkAdTitle {
        padding: 0 0 30px;
        position: relative;
        height: 20px;
        line-height: 20px;
        font-size: 16px;
        font-weight: bold;
        color: #000;
        letter-spacing: 000;
        border-bottom: 1px solid #666;
    }

    & > .powerLinkAdTitle > em {
        display: inline-block;
        padding-right: 28px;
        position: relative;
    }

    & > .powerLinkAdTitle > .adSpan {
        font-weight : bold;
        padding: 2px 8px 1px 8px !important;
        border: 1px solid #c8c8c8;
        font-size: 11px;
        line-height: 14px;
    }

    & > .powerLinkAdTitle > .adDetail {
        font-weight : normal;
        font-size: 12px;
    }

    & > .powerLinkAdTitle > a {
        float: right;
        color: #aaa;
        font-size: 12px;
        font-weight: normal;
        padding-right: 16px;

        &:hover {
            text-decoration: underline
        }
    }

    & > .powerLinkAdList {
        position: relative;
        overflow: hidden;
        width: 100%;
    }

    & > .powerLinkAdList > ul {
        position: relative;
        overflow: hidden;
        width: 1059px;
        margin-left: -49px;
    }

    & > .powerLinkAdList > ul > li {
        position: relative;
        width: 480px;
        padding: 16px 0 16px 49px;
        height: 121px;
        float: left;
        border-bottom: 1px solid #eeeeee;
    }

    & > .powerLinkAdList > ul > li > a {
        display: block;

        &:hover {
            text-decoration: underline
        }
    }

    & > .powerLinkAdList > ul > li > a > .powerLinkThumb {
        position: relative;
        width: 88px;
        height: 88px;
        border-radius: 2px 2px;
        overflow: hidden;
        float: right;
        margin-left: 24px;
    }

    & > .powerLinkAdList > ul > li > a > .powerLinkThumb > img {
        width: 100%;
        height: 100%;
    }

    & > .powerLinkAdList > ul > li > a > .powerLinkInfo > .powerLinkInfoName {
        display: block;
        padding: 10px 0;
        height: 24px;
        font-size: 14px;
        font-weight: bold;
        color: #1A70DD;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        letter-spacing: -1px;
        line-height: 0px;
    }

    & > .powerLinkAdList > ul > li > a > .powerLinkInfo > .powerLinkInfoName > .naverEmpty {
        margin-left: 4px;
        text-indent: -9999em;
        width: 30px;
        height:13px;
        display: inline-block;
        position: relative;
        vertical-align: -1px;
    }

    & > .powerLinkAdList > ul > li > a > .powerLinkInfo > .powerLinkInfoName > .naverPay {
        margin-left: 4px;
        text-indent: -9999em;
        width: 33px;
        height: 13px;
        display: inline-block;
        position: relative;
        background: url(${process.env.REACT_APP_CDN_IMG}/img_static/img_naver/naverPay_33_13.png) no-repeat 0 0;
        vertical-align: -1px;
    }

    & > .powerLinkAdList > ul > li > a > .powerLinkInfo > .powerLinkInfoName > .naverPayPlus {
        margin-left: 4px;
        text-indent: -9999em;
        width: 42px;
        height: 13px;
        display: inline-block;
        position: relative;
        background: url(${process.env.REACT_APP_CDN_IMG}/img_static/img_naver/naverPayPlus_42_13.png) no-repeat 0 0;
        vertical-align: -1px;
    }

    & > .powerLinkAdList > ul > li > a > .powerLinkInfo > .powerLinkInfoDetail {
        display: block;
        display: -webkit-box;
        color: #666;
        font-size: 12px;
        -o-text-overflow: ellipsis;
        text-overflow: ellipsis;
        white-space: normal;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        height: 40px;
        line-height: 18px;
        letter-spacing: -.5px;
        line-height: 22px;
    }
`
export default NaverPowerLink



// WEBPACK FOOTER //
// ./src/estimate_list/components/naverPowerLink/index.js